// 获取用户登录手机型号和uuid
    import axios from 'axios'
    import qs from 'qs';
    import { interfaceFn} from '../assets/util.js';
    export default function phoneUUID(onlineType){
        var ua = navigator.userAgent.split("(")[1].split(")")[0];
        var brand = "";
        var phone = [/IPHONE/gi, /huawei/gi, /mi/gi, /vivo/gi, /OPPO/gi, /samsung/gi, /SONY/gi, /Nokia/gi, /HTC/gi, /ZTE/gi, /Lenovo/gi, /ZUK/gi,]
        if (phone[0].test(ua)) {
        brand = "iPhone";
        } else if (phone[1].test(ua)) {
        brand = "HUAWEI";
        } else if (phone[2].test(ua)) {
        brand = "小米";
        } else if (phone[3].test(ua)) {
        brand = "vivo";
        } else if (phone[4].test(ua)) {
        brand = "OPPO"; 
        } else if (phone[5].test(ua)) {
        brand = "SAMSUNG";
        } else if (phone[6].test(ua)) {
        brand = "SONY";
        } else if (phone[7].test(ua)) {
        brand = "Nokia";
        } else if (phone[8].test(ua)) {
        brand = "HTC";
        } else if (phone[9].test(ua)) {
        brand = "ZTE";
        } else if (phone[10].test(ua) || phone[11].test(ua)) {
        brand = "Lenovo";
        } else {
        brand = "Android";
        }
        let uuid = window.localStorage.getItem("Phoneuuid")
        let ip = window.sessionStorage.getItem('ip');
        let area = window.sessionStorage.getItem('area');
        let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        let shopId = window.localStorage.getItem('shopId')
        // console.log(_this.$http);
        axios.post(interfaceFn() + '/yun/updateShopLocalMsg',qs.stringify({
            "shopId": shopId,
            "userId": userInfo.id,
            "userName": userInfo.nickname, 
            "type": 6,
            "online": Number(onlineType),//0：登出，1：登入 
            "hostAddress": ip,
            "hostName": brand + '--' + area,
            "diskSerialNumber": uuid,
        }),{
        headers: {
            'Content-Type':'application/x-www-form-urlencoded'
        }
        }).then(res =>{
            // alert(JSON.stringify(res.data.data.shopId));
        })       
    }


// WEBPACK FOOTER //
// ./src/assets/phoneUUID.js